
import React, { useState, useEffect } from 'react'
import { Formik } from 'formik'
import LedConfigDetails from './LedConfigDetails'
import SimpleTable from 'components/ActionsTable/SimpleTable'
import CircularProgress from 'components/Loader'
import SnackBar from 'components/SnackBar'
import CardBox from 'components/CardBox'
import { Box, TextField, Grid } from '@material-ui/core'
import MsgPopover from 'components/MsgPopover'
import { SwapHoriz } from '@material-ui/icons'
import API from 'util/Api'
import * as Yup from "yup";
import _ from "lodash";
import PopUpDialog from 'components/PopUpDialog';
import MergeLedRows from './MergeLedRows'

const LedConfigSchema = (config) => {
    return Yup.lazy(values => {
        console.log('schema values - ', values);
        return Yup.object().shape({
            name: Yup.string()
                .min(2, 'Too Short!')
                .required('Required'),
            device_id: Yup.string()
                .required('Required'),
            // led_version: Yup.string()
            //     .required('Required'),
            location_id: Yup.object()
                .required('Required'),
            type: Yup.string()
                .required('Required'),
            row: Yup.string()
                .required('Required'),
            col: Yup.string()
                .required('Required'),
            digit_length: values.digit_config ? Yup.number()
                .typeError('Must be a number')
                .min(0, 'Must be at least 0') : undefined,
            brightness: values.rgb_config ? Yup.number()
                .typeError('Must be a number')
                .min(0, 'Must be at least 0')
                .max(255, 'Must be at most 255') : undefined,
            coord_x: values.rgb_config ? Yup.number()
                .typeError('Must be a number')
                .min(0, 'Must be at least 0') : undefined,
            coord_y: values.rgb_config ? Yup.number()
                .typeError('Must be a number')
                .min(0, 'Must be at least 0') : undefined,
            config: Yup.array().of(
                Yup.object().shape({
                    // desc: Yup.string().required("Desc is required"),
                    type: Yup.string()
                        .required("Type is requried"),
                })
            ).min(1, "Need at least a row")

        });
    });

}

const DialogBox = (props) => {
    console.log("Fversion props", props)
    const [ip, setIP] = useState(props.clicked.ip);
    return (
        <Grid container>
            <Grid item xs={5}>
                <TextField id="standard-basic" label="IP Address" name="ip" value={ip} onChange={e => {
                    console.log('dialog-form', e)
                    setIP(e.target.value)
                    props.setDialogData({ [e.target.name]: e.target.value, ledId: props.clicked.id })
                }} />
            </Grid>
        </Grid>
    )
}

//fixme: currently a copy of console users , if no major changes required please use a single component
const LEDConfig = (props) => {
    console.log("LEDConfig", props)
    const [config, setConfig] = useState(null)
    const [values, setValues] = useState(null)
    const [ledConfig, setLedConfig] = useState(null)
    const [ledConfigList, setLedConfigList] = useState(null)
    const [resetF, setResetF] = useState(false);
    const [snackBar, setSnackBar] = useState({ open: false, msg: '', type: 'error' });
    const [dialog, setDialog] = useState({ open: false, content: '', header: '', agreeBtnTxt: '', disAgreeBtnTxt: '', type: '', maxWidth:undefined, callback: null });
    const [dialogData, setDialogData] = useState({});
    const [ledConfigRows, setLedConfigRows] = useState();
    const formatLedConfigList = (ledConfig) => {
        let tBody = []
        for (let body of ledConfig.body) {
            console.log("tBody", body)
            tBody.push(body.tableList)
        }
        let table = {
            ...ledConfig,
            'tbody': tBody
        }
        setLedConfigList(table)
    }
    const resetLedConfig = () => {

        setLedConfig(null)
        setResetF(true)
        console.log("reset form ")
    }
    const saveStaff = (e, { setSubmitting }) => {
        setSubmitting(true);

        API.post("ledConfig", JSON.stringify(e))
            .then((res) => {
                setSubmitting(false)
                console.log("ledpanelpost", res.data.data)
                resetLedConfig()
                formatLedConfigList(res.data.data.ledConfig)
                setSnackBar({ open: true, msg: res.data.msg, type: 'success' });

            })
            .catch((err) => {
                try {
                    setSnackBar({ open: true, msg: err.response.data.msg, type: 'error' });
                } catch {
                    setSnackBar({ open: true, msg: "Something went wrong", type: 'error' });
                }
                console.log("catch", err);
                setSubmitting(false)
            })
    }

    const getLedList = () => {
        API.get("ledConfig").then((res) => {
            console.log("ledConfigGet", res.data.data)
            setConfig(res.data.data.config.sections)
            setLedConfigRows(res.data.data.mergeRows);
            let sections = res.data.data.config.sections
            let data = {}
            for (let section of sections) {
                console.log("section", section)
                if (section.type === 'fields') {
                    section.fields.map(field => {
                        data[field.key] = field.value
                    })

                } else if (section.type === 'fieldArray') {
                    data[section.key] = []
                    section.multiValues.map(field => {
                        console.log("section.key", section.key, field)
                        data[section.key].push(field)
                    })
                }

            }
            console.log("setValues", data, sections)
            setValues(data)
            formatLedConfigList(res.data.data.ledConfig)
        })
            .catch((err) => {
                console.log("catch", err);
            })
    }
    useEffect(() => {
        getLedList()
    }, [])

    const handleStaffEdit = (clickedId) => {
        resetLedConfig();
        let ledConfSections = _.find(ledConfigList.body, { id: clickedId }).sections
        console.log("handleStaffEdit ", clickedId, ledConfSections)
        let data = {}
        for (let section of ledConfSections) {
            console.log("section", section)
            if (section.type === 'fields') {
                section.fields.map(field => {
                    data[field.key] = field.value
                })

            } else if (section.type === 'fieldArray') {
                data[section.key] = []
                section.multiValues.map(field => {
                    console.log("section.key", section.key, field)
                    data[section.key].push(field)
                })
            }

        }
        data.id = clickedId
        console.log("setValues", data)
        // scroll to top 
        document.body.style.height = 'auto'
        setTimeout(function () {
            setLedConfig(data)
            document.body.style.height = '100%'
        }, 50)
    }

    const handleRowMergeSubmit = (data) => {
        const ledPanelConfig = {
            config: [],
            id: data.id
        };

        const ledPanels = [];
        data.config.forEach(led_acc => {
            if (led_acc.merge_to_id && led_acc.merge_to_id.length > 0) {
                led_acc.merge_to_id.forEach(led_merge_id => {
                    ledPanelConfig.config.push({
                        id: led_merge_id.value,
                        merge_to_id: led_acc.id
                    });
                });
            }
            ledPanels.push(led_acc.id);
        });

        const ledPanelConfigIds = new Set(ledPanelConfig.config.map(cfg => cfg.id));
        const unmatchedLedPanelsIds = ledPanels.filter(id => !ledPanelConfigIds.has(id));

        unmatchedLedPanelsIds.forEach(ledId => {
            ledPanelConfig.config.push({
                id: ledId,
                merge_to_id: null
            });
        })

        API.post("ledConfigMerge", JSON.stringify(ledPanelConfig)).then((res) => {
            formatLedConfigList(res.data.data.ledConfig);
            handleDialogClose();
            setSnackBar({ open: true, msg: 'Merged LED rows successfully.', type: 'success' });
        }).catch((err) => {
            setSnackBar({ open: true, msg: err.response.data.msg, type: 'error' });
        });
    }

    const handleMergeRows = (ledPanelId) => {
        let ledConfSections = _.find(ledConfigList.body, { id: ledPanelId }).sections;
        let ledPanelConfig = [];
        let rgbConfig = false
        for (let section of ledConfSections) {
            if (section.type === 'fieldArray' && section.key === 'config') {
                ledPanelConfig = section.multiValues;
            }
            if(section.type === 'fields' && section.key === 'ledConfig') {
                rgbConfig = section.fields.find(obj => obj.key === 'rgb_config')?.value;
            }
        }

        const lookupLists = Object.fromEntries(
            ledConfigRows.fields
            .filter(f => Array.isArray(f.options) && f.key !== 'merge_to_id')
            .map(f => [f.key, f.options])
        );

        const mergeMap = {};
        const ledPanelList = ledPanelConfig.map((panel) => {
            const { id, merge_to_id, ...rest } = panel;

            if (merge_to_id) {
                if (!mergeMap[merge_to_id]) {
                    mergeMap[merge_to_id] = [];
                }
                mergeMap[merge_to_id].push(id);
            }

            const parts = Object.entries(rest).flatMap(([key, value]) => {
                if (value === null || value === "" || (key === 'rgb' && !rgbConfig)) return [];

                if (lookupLists[key]) {
                    if(Array.isArray(value)){
                        const titles = value
                            .map((v) => lookupLists[key].find((item) => item.value === v)?.title)
                            .filter(Boolean);    
                        return titles.length ? [titles.join(",")] : [];
                    } else{
                        const titles = lookupLists[key].find((item) => item.value === value)?.title;
                        return [titles];
                    }
                }
                return [value];
            });

            const title = parts.join("--").replace(/-+$/g, "");

            return {
                value: id,
                title,
                disabled: false
            };
        });

        let data = {}
        for (let section of ledConfSections) {
            if (section.type === 'fieldArray' && section.key === 'config') {
                data[section.key] = [];
                section.multiValues.map(field => {
                    let mergedPanels = [];
                    if (mergeMap[field.id]) {
                        mergedPanels = ledPanelList.filter(p =>
                            mergeMap[field.id].includes(p.value)
                        );
                    }
                    data[section.key].push({...field, merge_to_id:mergedPanels});
                })
            }
        }
        data.id = ledPanelId;

        const formRef = React.createRef();
        setDialog(prevState => ({...prevState, open:true, header:"Merge Rows", formRef, content: <MergeLedRows ref={formRef} config={ledConfigRows} rgbConfig={rgbConfig} data={data} ledPanelList={ledPanelList} handleRowMergeSubmit={handleRowMergeSubmit} />, agreeBtnTxt: 'Update', disAgreeBtnTxt: 'Cancel', maxWidth: 'lg'}))
    }

    const changeStatus = (id, status, cb) => {

        API.post("changeLedStatus", { ledId: id, status: status }).then((res) => {
            // const list = _.cloneDeep(ledConfigList)
            // let led = _.find(list.tbody,{id:id})
            // led.active = status
            // const tBody = _.unionBy(led,list.tbody)
            // list.tbody = tBody
            // setLedConfigList(list)
            cb(status)
        }).catch(err => { })
        handleDialogClose()
    }
    const onUpdate = (clicked) => {
        console.log("sendCommand", clicked)
        setDialog({
            open: true,
            header: "Update IP Address",
            content: <DialogBox clicked={clicked} setDialogData={setDialogData} />,
            agreeBtnTxt: 'Update',
            disAgreeBtnTxt: 'Cancel',
            type: 'ledIPUpdate'
        })
    }

    const statusUpdate = (id, checked, cb) => {
        let ledPanel = _.find(ledConfigList.tbody, (ledConfig) => ledConfig.id === id);
        setDialog({
            open: true,
            header: `${checked == true ? 'Activate' : 'Deactivate'} LED Panel`,
            content: `Are you sure you want to ${checked ? 'activate' : 'deactivate'} ${ledPanel.name}?`,
            agreeBtnTxt: 'Confirm',
            disAgreeBtnTxt: 'Cancel',
            type: 'ledPanelStatus',
            ledPanel: { id: id, active: checked },
            callback: cb
        })
    }

    const confirmDialogSubmit = (type) => {
        if (type === 'ledIPUpdate') {
            handleDialogSubmit()
        } else if (type === 'ledPanelStatus') {
            changeStatus(dialog.ledPanel.id, dialog.ledPanel.active, dialog.callback)
        }
    }

    const handleDialogSubmit = () => {
        console.log("agreeClicked", dialogData)
        if (Object.keys(dialogData).length > 0) {
            API.put('ledConfig', JSON.stringify(dialogData))
                .then((res) => {
                    handleDialogClose()
                    if (res.data.msg) {
                        setSnackBar({ open: true, msg: res.data.msg, type: 'success' });
                    }
                    getLedList()
                }).catch(err => {
                    handleDialogClose()
                    setSnackBar({
                        open: true,
                        msg: err?.response?.data?.msg
                            ? err.response.data.msg
                            : "Something went wrong",
                        type: "error",
                    });
                })
        }
    }

    const handleDialogClose = () => {
        setDialog({
            open: false,
            content: '',
            header: '',
            agreeBtnTxt: '',
            disAgreeBtnTxt: '',
            type: '',
            maxWidth:undefined,
            callback: null
        });
    }
    console.log("demoData.config", ledConfigList)
    return (
        <>
            {config && values &&
                <Formik
                    onSubmit={saveStaff}
                    onReset={resetLedConfig}
                    initialValues={values}
                    validationSchema={LedConfigSchema(config)}
                    resetInitalValue={true}
                >
                    <LedConfigDetails
                        ledConfig={ledConfig}
                        config={config}
                        resetFormik={resetF}
                        setFalse={() => { console.log('setResetF'); setResetF(false) }}
                    />
                </Formik>
            }
            {
                !config && !values && <CircularProgress />
            }
            {
                ledConfigList &&
                <div className="row">
                    <CardBox styleName="col-12" headerOutside heading={
                        <React.Fragment>
                            {ledConfigList.title}
                            <MsgPopover msg='Big table, scroll horizontally' timeout='1500'>
                                <Box display={{ xs: 'inline', md: 'none' }}><SwapHoriz color="primary" /></Box></MsgPopover>
                        </React.Fragment>}>
                        <SimpleTable
                            type="ledConfig"
                            table={ledConfigList}
                            onEdit={handleStaffEdit}
                            changeStatus={statusUpdate}
                            updateIP={onUpdate}
                            mergeRows={handleMergeRows}
                        />
                    </CardBox>
                </div>
            }
            <SnackBar
                open={snackBar.open}
                handleClose={() => { setSnackBar({ open: false, msg: "" }) }}
                message={snackBar.msg}
                type={snackBar.type}
            />
            <PopUpDialog
                fullWidth
                open={dialog.open}
                header={dialog.header}
                content={dialog.content}
                agreeBtnTxt={dialog.agreeBtnTxt}
                disAgreeBtnTxt={dialog.disAgreeBtnTxt}
                maxWidth={dialog.maxWidth}
                agreeClicked={() => { 
                    if(dialog?.formRef){
                        dialog?.formRef?.current?.submitForm();
                    }else{
                        confirmDialogSubmit(dialog.type, dialog.user)
                    }
                }}
                handleDialogClose={handleDialogClose}
            />
        </>
    )
}

export default LEDConfig